// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"fdc9563b","143":"725bb547","393":"44d6f36d","547":"b4b5928d","673":"0a3973e7","710":"c1d6f389","787":"f925bae0","957":"43b314d2"}[chunkId] + ".chunk.js";
};